// extracted by mini-css-extract-plugin
export default {"select":"User_select__iaxZi"};